export default {
  allBankOptions: state => {
    if (state.allBanks !== null) {
      return state.allBanks
        .filter(Boolean)
        .filter(item => item.identifier !== null && item.identifier !== undefined)
        .map(item => ({
          label: item.name ?? '',
          value: item.identifier?.trim(),
        }))
        .filter((item, index, self) => index === self.findIndex(b => b.value === item.value))
        .sort((a, b) => a.label.localeCompare(b.label))
    }
    return []
  },
}
